export const getCropperZoom = (params: {
  side: 'width' | 'height'
  imageSize: {
    width: number
    height: number
  }
  sizeRestrictions: {
    minHeight: number
    minWidth: number
  }
  coordinates: {
    width: number
    height: number
  }
}) => {
  const imageDimension = params.imageSize[params.side]
  const coordinateDimension = params.coordinates[params.side]

  const minDimension =
    params.side === 'width'
      ? params.sizeRestrictions.minWidth
      : params.sizeRestrictions.minHeight

  return (
    (imageDimension - coordinateDimension) / (imageDimension - minDimension)
  )
}
